/* WR-PDP-V1 (2026-09-23) — Página de producto: cotizador de envío por código postal y barra de compra fija
   en el celular. Snippets: wr-pdp-entrega, wr-pdp-sticky. Sin dependencias. */
(function () {
  'use strict';

  var ENDPOINT = 'https://interno.warrecord.net/api/cotizar-envio'; // WR-ENVIO-MEDIDAS-V1: peso, valor y caja salen de Shopify
  var WA = 'https://wa.me/5493515922788?text=';

  function fmt(n) {
    return '$' + Math.round(n).toLocaleString('es-AR');
  }

  function guardarCp(cp) {
    try { localStorage.setItem('wr_cp', cp); } catch (e) { /* almacenamiento no disponible */ }
  }

  function leerCp() {
    try { return localStorage.getItem('wr_cp') || ''; } catch (e) { return ''; }
  }

  /* ---- Cotizador de envío ------------------------------------------------ */
  /* WR-ENVIO-MEDIDAS-V1: la variante elegida en este momento (el selector de la ficha la cambia sin recargar) */
  function variante(form) {
    var sel = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = parseInt((sel && sel.value) || form.dataset.variant, 10);
    return id ? [{ variant_id: id, quantity: 1 }] : [];
  }

  function initCotizador(form) {
    var input = form.querySelector('.wr-pdp-cp__in');
    var btn = form.querySelector('.wr-pdp-cp__btn');
    var res = form.parentNode.querySelector('.wr-pdp-cp__res');
    if (!input || !btn || !res) return;
    if (!input.value) input.value = leerCp();

    function mensaje(txt, error) {
      res.innerHTML = '';
      var p = document.createElement('p');
      p.className = 'wr-pdp-cp__msg' + (error ? ' wr-pdp-cp__msg--error' : '');
      p.textContent = txt;
      if (error) {
        var a = document.createElement('a');
        a.href = WA + encodeURIComponent('Hola! Quiero cotizar un envío al código postal ' + input.value);
        a.target = '_blank';
        a.rel = 'noopener';
        a.textContent = ' Consultanos por WhatsApp.';
        p.appendChild(a);
      }
      res.appendChild(p);
    }

    function mostrar(opciones) {
      opciones = (opciones || []).slice().sort(function (a, b) { return a.precio - b.precio; });
      if (!opciones.length) {
        mensaje('No encontramos envíos a ese código postal.', true);
        return;
      }
      var ul = document.createElement('ul');
      ul.className = 'wr-pdp-cp__list';
      ul.setAttribute('role', 'list');
      opciones.forEach(function (o, i) {
        var li = document.createElement('li');
        if (i === 0) li.className = 'is-best';
        var info = document.createElement('span');
        info.className = 'wr-pdp-cp__info';
        var c = document.createElement('span');
        c.className = 'wr-pdp-cp__carrier';
        c.textContent = o.carrier + (o.servicio ? ' · ' + o.servicio : '');
        var d = document.createElement('span');
        d.className = 'wr-pdp-cp__days';
        d.textContent = o.dias_min === o.dias_max
          ? 'Llega en ' + o.dias_min + ' días hábiles'
          : 'Llega en ' + o.dias_min + ' a ' + o.dias_max + ' días hábiles';
        info.appendChild(c);
        info.appendChild(d);
        var p = document.createElement('span');
        p.className = 'wr-pdp-cp__price';
        p.textContent = fmt(o.precio);
        li.appendChild(info);
        li.appendChild(p);
        ul.appendChild(li);
      });
      res.innerHTML = '';
      res.appendChild(ul);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var cp = input.value.replace(/\D/g, '');
      if (cp.length < 4 || cp.length > 8) {
        mensaje('Ingresá un código postal válido (4 a 8 números).', false);
        input.focus();
        return;
      }
      guardarCp(cp);
      btn.disabled = true;
      mensaje('Calculando…', false);
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 12000) : null;
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cp: cp, origen: 'ficha', items: variante(form), peso: parseInt(form.dataset.peso, 10) || 500, valor: parseInt(form.dataset.valor, 10) || 1000 }),
        signal: ctrl ? ctrl.signal : undefined
      })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) { mostrar(Array.isArray(data) ? data : data && data.opciones); })
        .catch(function () { mensaje('No pudimos calcular el envío en este momento.', true); })
        .then(function () { if (timer) clearTimeout(timer); btn.disabled = false; });
    });
  }

  /* ---- Barra de compra fija (celular) ------------------------------------ */
  function initSticky() {
    var bar = document.querySelector('[data-wr-sticky]');
    var box = document.querySelector('.wr-buybox');
    if (!bar) return;
    document.body.classList.add('wr-has-sticky');

    // La barra se oculta solo mientras los botones de compra de la caja están a la vista
    // (no alcanza con que asome el borde de la caja: eso pasa ya en la primera pantalla).
    var ctaBox = box && box.querySelector('.product-form__buttons, a.button.button--full-width, .wr-pdp-price__wa');
    if ((ctaBox || box) && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-oculta', entries[0].isIntersecting);
      }, { threshold: 0.5 }).observe(ctaBox || box);
    }

    var comprar = bar.querySelector('[data-wr-comprar]');
    if (comprar) {
      comprar.addEventListener('click', function () {
        var destino = document.querySelector('.wr-buybox .shopify-payment-button__button')
          || document.querySelector('.wr-buybox .product-form__submit');
        if (destino && !destino.disabled) {
          destino.click();
        } else if (box) {
          box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    // Si cambia la variante, Dawn vuelve a renderizar el precio de la caja: la barra lo copia.
    var precioBox = box && box.querySelector('[id^="price-"]');
    var precioBar = bar.querySelector('[data-wr-sticky-price]');
    if (precioBox && precioBar && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var ahora = precioBox.querySelector('.wr-pdp-price__now');
        if (ahora) precioBar.textContent = ahora.textContent.trim();
      }).observe(precioBox, { childList: true, subtree: true, characterData: true });
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.wr-pdp-cp'), initCotizador);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
